// extracted by mini-css-extract-plugin
export default {"container":"SubstituteItem_container__z2ytO","selected":"SubstituteItem_selected__VW6g9","wrapper":"SubstituteItem_wrapper__849X1","text":"SubstituteItem_text__+t9xh"};